import { css } from 'styled-components';
import {
  BreakpointQueryName, ThemedFunctor,
} from '@doveit/bricks';

export const aside: ThemedFunctor = ({
  $order,
  $size,
  $addCss,
  theme,
}) => css`
  ${$addCss && $addCss}
  margin-top: ${theme.spaceUnits.mobile.BIG};

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    flex-shrink: 0;
    margin-top: 0;
    padding-left: ${theme.spaceUnits.desktop.MEDIUM};
    width: calc(${$size} + ${theme.spaceUnits.desktop.MEDIUM});

    ${$order && `
      order: ${$order};
    `}
  }
`;
